import React from 'react';
import type { LeadLabel } from '../types/leads';

interface LeadStatusFilterChipsProps {
  selectedStatuses: Set<LeadLabel>;
  onToggleStatus: (status: LeadLabel) => void;
  counts: Record<LeadLabel, number>;
}

const LEAD_STATUSES: Array<{
  value: LeadLabel;
  label: string;
  unselectedStyle: string;
  selectedStyle: string;
}> = [
  {
    value: 'hot',
    label: 'Hot',
    unselectedStyle: 'bg-red-100 text-red-700 border border-red-200',
    selectedStyle: 'bg-red-200 text-red-800 border-2 border-red-400 shadow-sm',
  },
  {
    value: 'warm',
    label: 'Warm',
    unselectedStyle: 'bg-orange-100 text-orange-700 border border-orange-200',
    selectedStyle: 'bg-orange-200 text-orange-800 border-2 border-orange-400 shadow-sm',
  },
  {
    value: 'cold',
    label: 'Cold',
    unselectedStyle: 'bg-blue-100 text-blue-700 border border-blue-200',
    selectedStyle: 'bg-blue-200 text-blue-800 border-2 border-blue-400 shadow-sm',
  },
  {
    value: 'new',
    label: 'New',
    unselectedStyle: 'bg-gray-100 text-gray-600 border border-gray-200',
    selectedStyle: 'bg-gray-200 text-gray-800 border-2 border-gray-400 shadow-sm',
  },
];

export function LeadStatusFilterChips({
  selectedStatuses,
  onToggleStatus,
  counts,
}: LeadStatusFilterChipsProps) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {LEAD_STATUSES.map((status) => {
        const isSelected = selectedStatuses.has(status.value);
        const count = counts[status.value] ?? 0;

        return (
          <button
            key={status.value}
            type="button"
            onClick={() => onToggleStatus(status.value)}
            className={`
              px-2 py-1 rounded-md text-xs font-medium
              transition-all duration-150 hover:opacity-80 cursor-pointer
              ${isSelected ? status.selectedStyle : status.unselectedStyle}
            `}
            aria-pressed={isSelected}
            aria-label={`Filter by ${status.label}, ${count} leads`}
          >
            {status.label} <span className="ml-0.5 text-[10px]">({count})</span>
          </button>
        );
      })}
    </div>
  );
}
